import Login from './views/Login.vue'
import NotFound from './views/404.vue'
import Home from './views/Home.vue'
import Main from './views/Main.vue'
import Table from './views/nav1/Table.vue'
import Form from './views/nav1/Form.vue'
import user from './views/nav1/user.vue'
import Page4 from './views/nav2/Page4.vue'
import Page5 from './views/nav2/Page5.vue'
import Page6 from './views/nav3/Page6.vue'
import echarts from './views/charts/echarts.vue'
import TableTest from './views/nav1/TableTest.vue'
import resource from './views/nav3/resource.vue'
import register from './views/appointment/register.vue'
import record from './views/appointment/record.vue'
import modify from './views/personalinfo/modify.vue'
import affiliate_company from './views/personalinfo/affiliate_company.vue'
import placeOrder from './views/consignation/placeOrder.vue'
import placeOrderTable from './views/consignation/placeOrderTable.vue'
import chooseDept from  './views/consignation/chooseDept.vue'
import cumstomer_addrList from './views/personalinfo/customerAddrList.vue'
import certificate from './views/consignation/certificateAuthenticity.vue' 
import emailConSign from './views/consignation/emailConSign.vue' 
import quoteSignature from './views/consignation/quoteSignature.vue' 
import questionnaire from './views/consignation/questionnaire.vue' 
import enterprise from './views/consignation/enterprise.vue' 
let routes =  [
    {
        path: '/login',
        component: Login,
        name: '',
        hidden: true
    },
    {
        path: '/404',
        component: NotFound,
        name: '',
        hidden: true
    },
    {
        path: '/updatePwd1',
        component: resolve => require(['./views/system/UpdatePw.vue'], resolve),
        name: '修改密码'
       
    },
    //{ path: '/main', component: Main },
    {
        path: '/',
        component: Home,
        name: '我的桌面',
        iconCls: 'fa fa-id-card-o',//图标样式class
        children: [
            { path: '/homeIndex',component: resolve => require(['./views/desktop/HomeIndex.vue'], resolve),  name: '主页' },
            { path: '/residentList',component: resolve => require(['./views/desktop/ResidentList.vue'], resolve), name: '用户管理列表' },
            { path: '/tableTest', component: TableTest, name: '列表测试' },
            { path: '/user', component: user, name: '列表' },        
        ]
    },
    {
        path: '/',
        component: Home,
        name: '系统管理',
        iconCls: 'fa fa-id-card-o',//图标样式class
        children: [
            { path: '/message',component: resolve => require(['./views/system/Message.vue'], resolve),  name: '消息管理' },
            { path: '/notice',component: resolve => require(['./views/system/Notice.vue'], resolve), name: '公告管理' },
            { path: '/parameter',component: resolve => require(['./views/system/Parameter.vue'], resolve), name: '参数设置' },
            { path: '/role',component: resolve => require(['./views/system/Role.vue'], resolve), name: '权限管理' },
            { path: '/updatePw',component: resolve => require(['./views/system/UpdatePw.vue'], resolve), name: '修改密码' },
            { path: '/userInfo',component: resolve => require(['./views/system/UserInfo.vue'], resolve), name: '账户管理' },
            { path: '/userMessage',component: resolve => require(['./views/system/UserMessage.vue'], resolve), name: '基本信息' },
            {path:'/resource',component:resource,name:'系统菜单'},
        ]
    },
    {
        path: '/',
        component: Home,
        name: '来访预约',
        iconCls: 'fa fa-id-card-o',
        children: [
            { path: '/appointment', component: register, name: '预约登记' },
            { path: '/record', component: record, name: '预约记录' }
        ]
    },
    {
        path: '/',
        component: Home,
        name: '委托管理',
        iconCls: 'fa fa-id-card-o',
        children: [
            { path: '/commission_order', component: placeOrder, name: '' },
            { path: '/consignationQuery', component: placeOrderTable, name: '委托查询' },
            { path: '/certificate', component: certificate, name: '证书报告防伪验证中心',meta:{role:false,keepAlive:false} },
            { path: '/emailConSign', component: emailConSign, name: '客户委托填写',meta:{role:false,keepAlive:false} },
            { path: '/quoteSignature', component: quoteSignature, name: '客户委托填写',meta:{role:false,keepAlive:false} },
            { path: '/questionnaire', component: questionnaire, name: '问卷调查',meta:{role:false,keepAlive:false} },
            { path: '/enterprise', component: enterprise, name: '企业信息',meta:{role:false,keepAlive:false} },
            
        ]
    },
    {
        path: '/',
        component: Home,
        name: '个人信息',
        iconCls: 'fa fa-id-card-o',
        children: [
            { path: '/modify', component: modify, name: '个人信息修改' },
            { path: '/affiliate_company', component: affiliate_company, name: '绑定所属公司' },
            { path: '/cumstomer_addrList', component: cumstomer_addrList, name: '收件地址管理' }
        ]
    },
    {
        path: '/',
        component: Home,
        name: 'Charts',
        iconCls: 'fa fa-bar-chart',
        children: [
            { path: '/echarts', component: echarts, name: 'echarts' }
        ]
    },
    {
        //配置* 
        path: '*',
        hidden: true,
        redirect: { path: '/404' }
    }
];

export default routes;


// WEBPACK FOOTER //
// ./src/routes.js